<template>
  <div class="min-h-screen">
    <TheHeader />
    <TheFileLibrary />

    <!-- what used to be WideContainer in Pastrami -->
    <div class="flex justify-center px-24 py-32 md:px-32">
      <div class="min-w-[320px] max-w-[1920px] grow">
        <TheAutonomousBanner page-level="ROUTE" />
        <slot />
      </div>
    </div>
  </div>

  <TheFeedbackPrompt />
  <div id="toast-wrapper" class="fixed z-50">
    <TheToast to="#toast-wrapper" />
  </div>
  <CookiesModal />
</template>

<script setup lang="ts">
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'

import { TABLEAU_SRC, TABLEAU_URL } from '~/constants/tableau'

import translations from './default.translations'

const lang = toRfc4646Locale(useI18nLocale())
const i18n = useI18n()
// /**
//  * Because this script write on the document, it is not possible to have it only on a specific page.
//  * If so, when navigating to this page on the browser side, we'll get the error.
//  * ``Failed to execute 'write' on 'Document': It isn't possible to write into a document from an asynchronously-loaded external script unless it is explicitly opened.``
//  * To avoid this, we load the script in the backoffice layout, and that way we'll always have it available.
//  * Note: i'm not a fan at all of this solution, but the only other solution i found was to reload the page
//  * if `window.tableau.Viz` was not present, and it's not so great in term of UX
//  */
useHead({
  title: i18n(translations.pageTitle),
  script: [{ src: TABLEAU_SRC }],
  link: [{ rel: 'dns-prefetch', href: TABLEAU_URL }],
  htmlAttrs: {
    lang,
  },
})
</script>
